import React, { Component } from 'react';
import AdminNavigationBar from './AdminNavigationBar';
import { Link } from 'react-router-dom';

class UserList extends Component {
    constructor() {
        super();
        this.state = {users: []};
        this.deleteUser = this.deleteUser.bind(this);
    }

    componentDidMount() {
        fetch(`/api/users`, { credentials: 'same-origin' }).then(response => {
            if (response.status === 200) {
                response.json().then(data => this.setState({users: data}));
            } else {
                location.href = '#/login';
            }
        });
    }

    render() {
        return (
            <div>
                <AdminNavigationBar />
                <div className="container col-md-6">
                    <h1>Użytkownicy</h1>
                    <div className="d-flex justify-content-end mt-3 mb-3">
                        <Link to="/users/new"><button className="btn btn-primary">Nowy użytkownik</button></Link>
                    </div>
                    <table className="table table-striped">
                        <thead>
                            <tr>
                            <th scope="col">Nazwa użytkownika</th>
                            <th scope="col">Rola</th>
                            <th scope="col">Akcje</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.users.map((user, index) => {
                                return (
                                    <tr>
                                        <td>{ user.username }</td>
                                        <td>{ user.userRole }</td>
                                        <td>
                                            {
                                                user.userRole != 'ROOT'
                                                    ? <button className="btn btn-sm btn-danger" data-toggle="modal" onClick={this.selectEntry(index)} data-target="#deleteEntryModal">Usuń</button>
                                                    : ''
                                            }
                                            
                                        </td>
                                    </tr>
                                );
                            })
                        }
                        </tbody>
                    </table>
                    
                </div>
                <div className="modal fade" id="deleteEntryModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Usuń rejestrację</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        </div>
                        <div className="modal-body">
                            <span>Czy na pewno chcesz usunąć użytkownika {this.selectedUsername()}?</span>
                        </div>
                        <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Nie</button>
                        <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.deleteUser}>Tak</button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        );
    }

    selectedUsername() {
        if (!this.state.users || this.state.selectedIndex === undefined || this.state.selectedIndex >= this.state.users.length) {
            return null;
        }

        return this.state.users[this.state.selectedIndex].username;
    }

    selectEntry(index) {
      return (evt) => {
        this.setState({selectedIndex: index});
      };
    }

    deleteUser() {
      const deletedEntryIndex = this.state.selectedIndex;

      fetch(
        `/api/users/${this.selectedUsername()}`,
        { method: 'DELETE', credentials: 'same-origin' }
      ).then(response => {
        if (response.status === 200) {
          const updatedUsers = this.state.users.slice();
          updatedUsers.splice(deletedEntryIndex, 1);
          this.setState({users: updatedUsers, selectedIndex: undefined});
        }
      });
    }
}

export default UserList;



// WEBPACK FOOTER //
// ./components/UserList.js